
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512","viewBox":"0 0 32 32","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.97 9.243l-2.81 11.242A1.997 1.997 0 0125.219 22H7.89a1.999 1.999 0 01-1.986-1.768L3.879 4H2.5a1.5 1.5 0 110-3h2.687a1.5 1.5 0 011.486 1.296L7.455 8H29a1 1 0 01.97 1.243zM7 27c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3zM25 27c0-1.654-1.346-3-3-3s-3 1.346-3 3 1.346 3 3 3 3-1.346 3-3z"}})])
          )
        }
      }
    